import {
  selectBuildingsDamage,
  selectCitiesCache,
  selectCurrentPlayer,
  selectHexes,
  selectSpecialBuildings,
  selectUnits
} from "../../redux/reducers/sharedStateReducer/selectors";
import {checkIfHexBlockedByEnemyUnit} from "./checkIfHexBlockedByEnemyUnit";
import {COMMON_BUILDING_TOKENS, TOKENS} from "../../constants/tokens";

export const calculateAvailableRecruitmentCells = (state) => {
  const currentPlayer = selectCurrentPlayer(state);
  const citiesCache = selectCitiesCache(state);
  const units = selectUnits(state);
  const hexes = selectHexes(state);
  const buildingsDamage = selectBuildingsDamage(state);
  const specialBuildings = selectSpecialBuildings(state);

  // Используем citiesCache для получения всех казарм игрока
  const playerColor = currentPlayer.color;
  const playerCities = citiesCache[playerColor] || [];

  // Собираем все казармы из всех городов игрока (и центральных, и базовых)
  const allPlayerBarracks = [];
  playerCities.forEach(city => {
    const cityBarracks = city[COMMON_BUILDING_TOKENS.BARRACKS];
    if (cityBarracks) {
      allPlayerBarracks.push(...cityBarracks);
    }
  });

  // Убираем дубликаты
  const uniqueBarracks = [...new Set(allPlayerBarracks)];

  // Фильтруем казармы, которые не заняты другими отрядами
  const occupiedHexKeys = new Set();
  if (units) {
    units.forEach(unit => {
      if (unit.hexKey) {
        occupiedHexKeys.add(unit.hexKey);
      }
    });
  }

  // Фильтруем казармы: не заняты и не заблокированы вражеским отрядом
  return uniqueBarracks.filter(key => {
    // Не занята другим отрядом
    if (occupiedHexKeys.has(key)) {
      return false;
    }
    // Не заблокирована вражеским отрядом
    return !checkIfHexBlockedByEnemyUnit(key, TOKENS.BARRACKS, currentPlayer.id, units, hexes, specialBuildings, buildingsDamage);
  });
};